
import { createApp, configureCompat } from 'vue';
import vueNumeralFilterInstaller from 'vue-numeral-filter';
import { Swiper } from "swiper/bundle";
import _ from "lodash";
import VueTippy from "vue-tippy";
import 'tippy.js/dist/tippy.css'

// Importar las dependencias necesarias
require('./scripts');
require('./map');

// Configurar compatibilidad para evitar errores de deprecación relacionados con los atributos falsos
configureCompat({ ATTR_FALSE_VALUE: false });

const app = createApp();

// Asignar Swiper a la ventana global
window.Swiper = Swiper;

// Asignar lodash a la ventana global
window._ = _;

// Instalar el filtro numeral de Vue
app.use(vueNumeralFilterInstaller, { locale: 'es' });

app.use(
  VueTippy,
  {
    directive: 'tippy',
    component: 'tippy',
    componentSingleton: 'tippy-singleton',
    defaultProps: {
      placement: 'auto-end',
      allowHTML: true,
      theme: 'custom',
    },
  }
)

// Registra componentes necesarios
app.component('neighborhood-map', require('./components/NeighborhoodMap').default);
app.component('buscadorBarrios', require('./components/BuscadorBarrios').default);
app.component('gastosDeEscrituraCompra', require('./components/GastosDeEscrituraCompraComponent').default);
app.component('gastosDeEscrituraVenta', require('./components/GastosDeEscrituraVentaComponent').default);
app.component('gastosDeAlquiler', require('./components/GastosDeAlquilerComponent').default);
app.component('preciosAlquileresCaba', require('./components/PreciosAlquileresCabaComponent').default);
app.component('altaInicioContrato', require('./components/AltaInicioContratoComponent').default);
app.component('garantiaPremiumGroup', require('./components/GarantiaPremiumGroupComponent').default);
app.component('propiedadMap', require('./components/PropiedadMapComponent').default);
app.component('gastosDeValoracion', require('./components/GastosDeValoracionComponent').default);
app.component('chart-preview-component', require('./components/ChartPreviewComponent').default);
app.component('chart-full-component', require('./components/ChartFullComponent').default);
app.component('indicadores', require('./components/IndicadoresComponent').default);
app.component('propiedades', require('./components/Propiedades').default);
app.component('mapaCushman', require('./components/MapaCushman').default);

// Montar la aplicación en el elemento con el ID "app" en el DOM
app.mount('#app');
